import { ICurrencyState } from '@/store/currency';
import { ICurrencyGetters } from './getters.types';
import { ICurrency, Currency } from '@/models';

export const getters: ICurrencyGetters = {
  getCurrencies(state: ICurrencyState): ICurrency[] {
    return state.currencies.map(data => new Currency(data));
  },

  getCurrencyById: (state: ICurrencyState) => (
    id: number
  ): ICurrency | undefined => {
    const data = state.currencies.find(currency => currency.id === id);
    if (!data) {
      return undefined;
    }

    return new Currency(data);
  },

  getCurrencyByCode: (state: ICurrencyState) => (code: string) => {
    const data = state.currencies.find(currency => currency.code === code);
    if (!data) {
      return undefined;
    }
    return new Currency(data);
  }
};
